var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ins',{class:['adsbygoogle', 'vue-adsense', 'mb-3'],style:(_vm.adStyle),attrs:{"data-ad-client":_vm.adClient,"data-ad-slot":_vm.adSlot,"data-ad-format":_vm.adFormat}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-090b0796","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vendor/vue-adsense/vue-adsense.vue
// module id = null
// module chunks = 